export default "__VITE_ASSET__01fcc533__"